import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './kpi-data.reducer';
import { IKpiData } from 'app/shared/model/kpi-data.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, DEFAULT_ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const KpiData = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const kpiDataList = useAppSelector(state => state.kpiData.entities);
  const loading = useAppSelector(state => state.kpiData.loading);
  const totalItems = useAppSelector(state => state.kpiData.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="kpi-data-heading" data-cy="KpiDataHeading">
        <Translate contentKey="fleetSenseApp.kpiData.home.title">Kpi Data</Translate>
        <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> <Translate contentKey="fleetSenseApp.kpiData.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fleetSenseApp.kpiData.home.createLabel">Create new Kpi Data</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {kpiDataList && kpiDataList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.kpiData.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('created')}>
                  <Translate contentKey="fleetSenseApp.kpiData.created">Created</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('odometer')}>
                  <Translate contentKey="fleetSenseApp.kpiData.odometer">Odometer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('distanceTravelled')}>
                  <Translate contentKey="fleetSenseApp.kpiData.distanceTravelled">Distance Travelled</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('speedAvg')}>
                  <Translate contentKey="fleetSenseApp.kpiData.speedAvg">Speed Avg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('speedMax')}>
                  <Translate contentKey="fleetSenseApp.kpiData.speedMax">Speed Max</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('speedMin')}>
                  <Translate contentKey="fleetSenseApp.kpiData.speedMin">Speed Min</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('loadAvg')}>
                  <Translate contentKey="fleetSenseApp.kpiData.loadAvg">Load Avg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('loadMax')}>
                  <Translate contentKey="fleetSenseApp.kpiData.loadMax">Load Max</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('loadMin')}>
                  <Translate contentKey="fleetSenseApp.kpiData.loadMin">Load Min</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('absCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.absCount">Abs Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('absMax')}>
                  <Translate contentKey="fleetSenseApp.kpiData.absMax">Abs Max</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('rssCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.rssCount">Rss Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('rssMax')}>
                  <Translate contentKey="fleetSenseApp.kpiData.rssMax">Rss Max</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('breakCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.breakCount">Break Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('breakMax')}>
                  <Translate contentKey="fleetSenseApp.kpiData.breakMax">Break Max</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('breakCountDistanceHundred')}>
                  <Translate contentKey="fleetSenseApp.kpiData.breakCountDistanceHundred">Break Count Distance Hundred</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('breakMaxOdometerHundred')}>
                  <Translate contentKey="fleetSenseApp.kpiData.breakMaxOdometerHundred">Break Max Odometer Hundred</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('alertTotalCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.alertTotalCount">Alert Total Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('alertSensorCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.alertSensorCount">Alert Sensor Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('alertFenceCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.alertFenceCount">Alert Fence Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('alertIdentificationCount')}>
                  <Translate contentKey="fleetSenseApp.kpiData.alertIdentificationCount">Alert Identification Count</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.kpiData.truckImplement">Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.kpiData.company">Company</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {kpiDataList.map((kpiData, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${kpiData.id}`} color="link" size="sm">
                      {kpiData.id}
                    </Button>
                  </td>
                  <td>{kpiData.created ? <TextFormat type="date" value={kpiData.created} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{kpiData.odometer}</td>
                  <td>{kpiData.distanceTravelled}</td>
                  <td>{kpiData.speedAvg}</td>
                  <td>{kpiData.speedMax}</td>
                  <td>{kpiData.speedMin}</td>
                  <td>{kpiData.loadAvg}</td>
                  <td>{kpiData.loadMax}</td>
                  <td>{kpiData.loadMin}</td>
                  <td>{kpiData.absCount}</td>
                  <td>{kpiData.absMax}</td>
                  <td>{kpiData.rssCount}</td>
                  <td>{kpiData.rssMax}</td>
                  <td>{kpiData.breakCount}</td>
                  <td>{kpiData.breakMax}</td>
                  <td>{kpiData.breakCountDistanceHundred}</td>
                  <td>{kpiData.breakMaxOdometerHundred}</td>
                  <td>{kpiData.alertTotalCount}</td>
                  <td>{kpiData.alertSensorCount}</td>
                  <td>{kpiData.alertFenceCount}</td>
                  <td>{kpiData.alertIdentificationCount}</td>
                  <td>
                    {kpiData.truckImplement ? <Link to={`truck-implement/${kpiData.truckImplement.id}`}>{kpiData.truckImplement.licensePlate}</Link> : ''}
                  </td>
                  <td>{kpiData.company ? <Link to={`company/${kpiData.company.id}`}>{kpiData.company.name}</Link> : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${kpiData.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${kpiData.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${kpiData.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.kpiData.home.notFound">No Kpi Data found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={kpiDataList && kpiDataList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default KpiData;
